export function SocialProof() {
  const placeholders = ["Acme", "Globex", "Initech", "Umbrella", "Hooli", "Soylent"]
  return (
    <div className="border-y bg-muted/30">
      <div className="container mx-auto px-6 py-10">
        <p className="text-center text-xs font-medium uppercase tracking-wider text-muted-foreground">
          Türkiye'nin önde gelen ekipleri Hirefy ile büyüyor
        </p>
        <div className="mt-6 grid grid-cols-2 items-center gap-6 opacity-60 sm:grid-cols-3 md:grid-cols-6">
          {placeholders.map((name) => (
            <div
              key={name}
              className="text-center text-sm font-semibold tracking-tight text-muted-foreground"
            >
              {name}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
